<template>
    <div class="introduce_item">
        <span class="text">{{ introduce.realName }}</span>
        <div class="avatar">
            <img class="avatar-img" :src="
          introduce.headImage
            ? introduce.headImage
            : require('../../../assets/images/mr.jpg')
        " alt="" />
        </div>
        <div class="dh">
            <img :src="require('../../../assets/images/dh.png')" alt="" />
        </div>
        <div class="tag_position">
            <div class="introduce">
                <div class="dsahed_up">
                    <template v-if="introduce.typeList.length">
                        <Tag v-for="(item, index) in introduce.typeList" :key="item" :color="index === 0 ? 'blue' : index === 1 ? 'red' : 'yellow'">{{ item }}</Tag>
                    </template>
                    <div class="text_dq" :title="introduce.unitDuty">
                        {{ introduce.unitDuty }}
                    </div>
                </div>
                <div class="dashed"></div>
                <div class="text_detail" :title="introduce.academicAchievements">
                    {{ introduce.academicAchievements }}
                </div>
                <!-- <div class="pj_pic">
          <div class="pic_item">
            <img
              :src="require('../../../assets/images/good.png')"
              alt=""
            />&nbsp;&nbsp; 444
          </div>
          <div class="pic_item">
            <img
              :src="require('../../../assets/images/comments.png')"
              alt=""
            />&nbsp;&nbsp; 444
          </div>
        </div> -->
            </div>
            <div class="invate">
                <img class="pointer" @click="invateTeach" :src="require('../../../assets/images/invateCourse.png')" alt="邀约讲课" />
            </div>
        </div>
    </div>
    <Modal v-model="invateShow" footer-hide class-name="fmodel" :mask-closable="false">
        <Form :model="form" ref="formRef" :rules="ruleValidate" label-position="left" :label-width="80">
            <FormItem label="课程主题" prop="Name">
                <Input v-model="form.Name" placeholder="如：社区氛围如何营造"></Input>
            </FormItem>
            <FormItem label="起止时间" prop="daterange">
                <DatePicker v-model="form.daterange" format="yyyy-MM-dd HH:mm:ss" type="datetimerange" placeholder="请选择起止时间" style="width: 100%" />
            </FormItem>
            <div class="dq">
                <FormItem label="参训单位" prop="JoinUnit">
                    <Input v-model="form.JoinUnit" placeholder="请填写参训单位"></Input>
                </FormItem>
                <FormItem label="授课人数" prop="JoinUserCount">
                    <Input v-model="form.JoinUserCount" placeholder="请填写授课人数"></Input>
                </FormItem>
            </div>

            <div class="dq">
                <FormItem label="联系人" prop="ContactUser">
                    <Input v-model="form.ContactUser" placeholder="请填写联系人"></Input>
                </FormItem>
                <FormItem label="联系电话" prop="Mobile">
                    <Input v-model="form.Mobile" placeholder="请填写联系电话"></Input>
                </FormItem>
            </div>

            <FormItem label="授课地点" prop="TeachingAddress">
                <Input class="textarea" v-model="form.TeachingAddress" placeholder="请填写授课地点" type="textarea" :rows="12"></Input>
            </FormItem>
        </Form>
        <div class="ljyy">
            <img @click="submit" :src="require('../../../assets/images/ljyy.png')" alt="" />
        </div>
    </Modal>
</template>

<script setup>
import { Message } from 'view-ui-plus';
import axios from 'axios';
import { timeValidate } from '../../../utils/tools';
import { validatephonenumber, isInteger } from '../../../utils/validateRules';
import { ref, defineProps, defineEmits, watch } from 'vue';
const props = defineProps({
    introduce: Object,
});
const formRef = ref();
const ruleValidate = {
    Name: [{ required: true, message: '课程主题不能为空', trigger: 'blur' }],
    daterange: [
        {
            required: true,
            type: 'array',
            message: '请选择起止时间',
            trigger: 'change',
        },
    ],
    JoinUnit: [{ required: true, message: '请填写参训单位', trigger: 'blur' }],
    JoinUserCount: [
        {
            required: true,
            validator: isInteger,
            trigger: 'blur',
        },
    ],
    ContactUser: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
    Mobile: [
        {
            required: true,
            validator: validatephonenumber,
            trigger: 'blur',
        },
    ],
    TeachingAddress: [
        { required: true, message: '请填写授课地点', trigger: 'blur' },
    ],
};
const invateShow = ref(false);
function invateTeach() {
    form.value = {
        StartDate: '',
        EndDate: '',
        daterange: [],
    };
    invateShow.value = true;
}
const form = ref({
    StartDate: '',
    EndDate: '',
    daterange: [],
});
const skList = ref([]); // 授课对象
function submit() {
    form.value.TeacherId = props.introduce.id;
    form.value.TeacherName = props.introduce.realName;
    form.value.StartDate = timeValidate(form.value.daterange[0]);
    form.value.EndDate = timeValidate(form.value.daterange[1]);
    formRef.value.validate((valid) => {
        if (valid) {
            let url = '/ssapi/form/1/3';
            axios
                .post(`https://zhdj.scycjy.gov.cn${url}`, form.value, {})
                .then((res) => {
                    Message['success']({
                        background: true,
                        content: '邀约讲课成功',
                    });
                    invateShow.value = false;
                });
        }
    });
}
</script>
<style>
.fmodel .ivu-modal {
    width: 614px !important;
    min-height: 672px !important;
}
.fmodel .ivu-modal-body {
    width: 614px !important;
    min-height: 672px !important;
    background: url('../../../assets/images/invateTeach.png') no-repeat center
        center !important;
    background-size: 100% 100% !important;
    padding: 90px 20px 20px !important;
}
.fmodel .ivu-modal-content {
    background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
.introduce_item {
    width: 346px;
    height: 614px;
    background: url(../../../assets/images/peo_introduce.png) no-repeat center
        center;
    background-size: 100% 100%;
    position: relative;
    .text {
        color: #fff;
        font-size: 18px;
        display: inline-block;
        position: absolute;
        top: 302px;
        left: 50%;
        transform: translate(-50%, -110%);
    }
    .avatar-img {
        width: 250px;
        height: 265px;
    }
    .tag_position {
        position: absolute;
        top: 310px;
        left: 6%;
        right: 6%;
        margin: 10px 0;
        // transform: translate(-50%, 0%);
        .text_dq {
            width: 100%;
            height: 46px;
            line-height: 24px;
            margin-top: 5px;
            font-size: 16px;
            color: #931000;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .text_detail {
            font-size: 14px;
            color: #633b3b;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
        .dashed {
            height: 2px;
            border-top: 1px dashed #d81735;
            // margin: 10px 0;
        }
        .dsahed_up {
            height: 78px;
        }
        .pj_pic {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .pic_item {
                margin-left: 20px;
                display: flex;
                justify-content: center;
            }
        }
        .invate {
            margin-top: 10px;
            display: flex;
            justify-content: center;
            img {
                width: 136px;
                height: 38px;
            }
        }
        .introduce {
            height: 225px;
        }
    }
    .dh {
        position: absolute;
        top: 40%;
        left: 10%;
        right: 6%;
        margin: 10px 0;
        img {
            width: 50px;
            height: 45px;
        }
    }
    .avatar {
        position: absolute;
        top: -1%;
        left: 0;
        right: 0;
        margin: 10px auto;
        width: 220px;
        img {
            display: block;
            width: 220px;
            margin: 0 auto;
        }
    }
}
.ljyy {
    display: flex;
    justify-content: center;
    img {
        width: 124px;
        height: 37px;
    }
}
.dq {
    display: flex;
    justify-content: space-between;
}
.pointer {
    cursor: pointer;
}
</style>
